import { render, staticRenderFns } from "./vAdditionalMeasurementModal.vue?vue&type=template&id=44a70715"
import script from "./vAdditionalMeasurementModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vAdditionalMeasurementModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports